
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
.outline-breadcrumbs{
  color:var(
    --outline-breadcrumb-text-color-default,
    var(--outline-breadcrumb--default-text-color-default)
  );
  background:var(
    --outline-breadcrumb-bg-color,
    var(--outline-breadcrumb--default-bg-color)
  );
  padding:var(
    --outline-breadcrumb-bg-padding,
    var(--outline-breadcrumb--default-bg-padding)
  );
}

a, ::slotted(a){
  font-family:var(--ff-body);
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:300ms;
  -webkit-text-decoration:var(
    --outline-breadcrumb-link-decoration-default,
    var(--outline-breadcrumb--default-link-decoration-default)
  );
          text-decoration:var(
    --outline-breadcrumb-link-decoration-default,
    var(--outline-breadcrumb--default-link-decoration-default)
  );
  color:var(
    --outline-breadcrumb-link-color-default,
    var(--outline-breadcrumb--default-link-color-default)
  );
}

a:hover,
::slotted(a:hover){
  -webkit-text-decoration:var(
    --outline-breadcrumb-link-decoration-hover,
    var(--outline-breadcrumb--default-link-decoration-hover)
  );
          text-decoration:var(
    --outline-breadcrumb-link-decoration-hover,
    var(--outline-breadcrumb--default-link-decoration-hover)
  );
  color:var(
    --outline-breadcrumb-link-color-hover,
    var(--outline-breadcrumb--default-link-color-hover)
  );
}

a:focus,
::slotted(a:focus){
  -webkit-text-decoration:var(
    --outline-breadcrumb-link-decoration-focus,
    var(--outline-breadcrumb--default-link-decoration-focus)
  );
          text-decoration:var(
    --outline-breadcrumb-link-decoration-focus,
    var(--outline-breadcrumb--default-link-decoration-focus)
  );
  outline:none;
  color:var(
    --outline-breadcrumb-link-color-focus,
    var(--outline-breadcrumb--default-link-color-focus)
  );
}

.separator{
  margin-left:var(
    --outline-breadcrumb-separator-spacing,
    var(--outline-breadcrumb--default-separator-spacing)
  );
  margin-right:var(
    --outline-breadcrumb-separator-spacing,
    var(--outline-breadcrumb--default-separator-spacing)
  );
}
`;